import React, { useEffect, useState } from 'react';
import DOMPurify from 'dompurify';

export const VideoParagraph = ({ paragraph, text, src }) => {
  const [videoData, setVideoData] = useState({
    width: '100%',
    height: 'auto',
    text: '',
    src: ''
  });

  useEffect(() => {
    if (text && src){
        setVideoData({
            text: text,
            src: src
        });
        return 
    }
    // If paragraph contains content in template format, parse it
    if (paragraph && paragraph.includes('{% set')) {
      parseVideoTemplateString(paragraph);
    } else {
      // Otherwise use directly provided properties
      if (paragraph) {
        setVideoData({
          width: paragraph.width ? paragraph.width : '100%',
          height: paragraph.height ? paragraph.height : 'auto',
          text: paragraph.caption ? paragraph.caption : text,
          src: src
          });
      }else{
        setVideoData({
          width: '100%',
          height: 'auto',
          text: text,
          src: src
        });
      }
    }
  }, [paragraph, text, src]);

  const parseVideoTemplateString = (templateString) => {
    try {
      // Extract variables from the template string
      const regex = /{% set ([^=]+)=\s*['"]([^'"]*)['"]\s*,\s*['"]([^'"]*)['"]\s*,\s*[^'"]*\(['"]([^'"]*)['"]\)\s*,\s*['"]([^'"]*)['"]\s*%}/;
      const match = templateString.match(regex);
    

      if (match && match.length >= 6) {
        const width = match[2] || '100%';
        const height = match[3] || 'auto';
        const text = match[4] || '';
        const src = match[5] || '';
        
        setVideoData({ width, height, text, src });
      }
    } catch (error) {
      console.error('Error parsing video template string:', error);
    }
  };

  const renderVideo = () => {
    const { src, width, height } = videoData;
    
    // Check if it's a YouTube video
    const isYoutube = src && (
      src.includes('youtube.com') || 
      src.includes('youtu.be') ||
      src.includes('youtube.com/embed')
    );

    if (isYoutube) {
      // Handle YouTube embed
      let embedUrl = src;
      
      // Convert standard YouTube URL to embed format if needed
      if (src.includes('watch?v=')) {
        const videoId = src.split('watch?v=')[1].split('&')[0];
        embedUrl = `https://www.youtube.com/embed/${videoId}`;
      } else if (src.includes('youtu.be/')) {
        const videoId = src.split('youtu.be/')[1].split('?')[0];
        embedUrl = `https://www.youtube.com/embed/${videoId}`;
      }

      return (
        <iframe
          src={DOMPurify.sanitize(embedUrl)}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title={videoData.text || "Video"}
          className="w-full rounded-lg h-[500px]"
        />
      );
    } else if (src) {
      // Handle local video file
      return (
        <video
          src={src}
          width={width}
          height={height}
          controls
          className="w-full rounded-lg"
        >
          Your browser does not support the video tag.
        </video>
      );
    }
    
    return <div>No video source provided</div>;
  };

  return (
    <div className="video-paragraph mb-4">
      <div className="video-container w-full h-auto min-h-[500px]">
        {renderVideo()}
      </div>
      {videoData.text && (
        <p className="text-sm text-gray-500 mt-2">{videoData.text}</p>
      )}
    </div>
  );
};
